import React, { useState, useEffect } from 'react';
import { fetchOptions, addAppointment } from '../../../API/functions';
import { CircularProgress } from '@mui/material';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Ensure you import this
import { useFileContext } from '../../../Context/FileContext';

const AddAppointmentForm = () => {
    const [firstSelect, setFirstSelect] = useState('');
    const [secondSelectOptions, setSecondSelectOptions] = useState([]);
    const [selectedOptionId, setSelectedOptionId] = useState('');
    const [clientName, setClientName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [appointmentDate, setAppointmentDate] = useState('');
    const [appointmentTime, setAppointmentTime] = useState('');
    const [appointmentEndTime, setAppointmentEndTime] = useState('');
    const [loading, setLoading] = useState(false);
    const { setShowModal } = useFileContext()

    useEffect(() => {
        if (firstSelect) {
            fetchOptions(firstSelect)
                .then(data => setSecondSelectOptions(data))
                .catch(error => console.error('Error fetching data:', error));
        } else {
            setSecondSelectOptions([]);
        }
    }, [firstSelect]);

    const handleFirstSelectChange = (e) => setFirstSelect(e.target.value);
    const handleSecondSelectChange = (e) => setSelectedOptionId(e.target.value);
    const handleClientNameChange = (e) => setClientName(e.target.value);
    const handlePhoneNumberChange = (e) => setPhoneNumber(e.target.value);
    const handleAppointmentDateChange = (e) => setAppointmentDate(e.target.value);
    const handleAppointmentTimeChange = (e) => setAppointmentTime(e.target.value);
    const handleAppointmentEndTimeChange = (e) => setAppointmentEndTime(e.target.value)
    const isFormComplete = () => {
        return (
            firstSelect &&
                selectedOptionId &&
                clientName.trim() !== '' &&
                phoneNumber.trim() !== '' &&
                appointmentDate !== '' &&
                appointmentTime !== '' &&
                firstSelect === "others" ? appointmentEndTime : true
        );
    };

    const AddButton = () => (
        <div>
            {!loading ? <button onClick={() => handleAddClick()} disabled={!isFormComplete()}>
                Add
            </button> :
                <CircularProgress />
            }
        </div>
    );

    const othersData = (appointment, endTime) => {
        appointment.endTime = endTime[0] + ':' + endTime[1]
        appointment.serviceId = "others"
        return appointment
    }

    const handleAddClick = async () => {
        setLoading(true);

        try {
            // Fetch service details to get duration (e.g., in minutes)
            const service = secondSelectOptions.find((val) => val._id === selectedOptionId);

            if (!service && firstSelect !== "others") {
                throw new Error('Service not found');
            }

            const time = appointmentTime.split(':')
            const endTime = appointmentEndTime.split(':')
            if (time[0] === "00") {
                time[0] = "12"
            }


            // Adjust the appointment object to send
            const appointment = {
                serviceId: selectedOptionId,
                customerName: clientName,
                customerEmail: '',
                customerPhone: phoneNumber,
                appointmentDate: appointmentDate,
                startTime: time[0] + ':' + time[1],
            };
            if (firstSelect === "others") {
                othersData(appointment, endTime);
                console.log("time", time, "end time ", endTime);

                if (time[0] >= endTime[0]) {
                    toast.error("invalid end time", {
                        position: 'bottom-right',
                        draggable: true,
                    })
                    setLoading(false);
                    return;
                }
                else if (time[0] === endTime[0]) {
                    if (time[1] >= endTime[1]) {
                        toast.error("invalid end time", {
                            position: 'bottom-right',
                            draggable: true,
                        })
                        setLoading(false);
                        return
                    }
                }
            }

            await addAppointment(appointment);
            toast.success('Appointment added successfully', {
                position: 'bottom-right',
                draggable: true,
            });
            setShowModal(false)
        } catch (error) {
            toast.error(`Failed to add appointment: ${error.message}`, {
                position: 'bottom-right',
                draggable: true,
            });
        }
        setLoading(false);
    };
    return (
        <div>
            <h2>Add Appointment</h2>
            <select value={firstSelect} onChange={handleFirstSelectChange}>
                <option value="">Select Type</option>
                <option value="services">Service</option>
                <option value="courses">Course</option>
                <option value="others">Other</option>
            </select>

            {firstSelect && firstSelect !== "others" && (
                <select value={selectedOptionId} onChange={handleSecondSelectChange}>
                    <option value="">Select {firstSelect.slice(0, -1)}</option>
                    {secondSelectOptions.map(option => (
                        <option key={option._id} value={option._id}>
                            {option.name}
                        </option>
                    ))}
                </select>
            )}

            <input
                type="text"
                placeholder="Client Name"
                value={clientName}
                onChange={handleClientNameChange}
            />
            <input
                type="text"
                placeholder="Phone Number"
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
            />
            <input
                type="date"
                placeholder="Appointment Date"
                value={appointmentDate}
                onChange={handleAppointmentDateChange}
            />
            <h3>start Time</h3>
            <input
                type="time"
                placeholder="Appointment Time"
                value={appointmentTime}
                onChange={handleAppointmentTimeChange}
            />
            {firstSelect === "others" &&
                <>
                    <h3>End Time</h3>
                    <input
                        type="time"
                        placeholder="Appointment Time"
                        value={appointmentEndTime}
                        onChange={handleAppointmentEndTimeChange}
                    />
                </>
            }
            <AddButton />
            <ToastContainer />
        </div >
    );
};

export default AddAppointmentForm;
